<script>
	import { createEventDispatcher } from "svelte";
	import { clickOutside } from "../../../../../helpers";

	const dispatch = createEventDispatcher();

	let modal;
</script>


<div 
	class="modal-background"
	use:clickOutside 
	on:click_outside={() => dispatch('hide-popup')} 
>

<div bind:this={modal} class="modal" role="dialog" aria-modal="true"></div>
	<slot></slot>
</div>

<style>
	.modal-background {
    z-index: 2;
		position: relative;
	}
</style>
